const AppVersion = () => {
    const version = '1.40.0';

    return (
        <div>
            <p>App Version: {version}</p>
        </div>
    );
};

export default AppVersion;
